import { render, staticRenderFns } from "./envelope-list.vue?vue&type=template&id=cdf8d476"
import script from "./envelope-list.vue?vue&type=script&lang=js"
export * from "./envelope-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports